export default {
  state: {
    unavailableDrivers: {
      list: [],
      selected: '',
      loading: false
    }
  },
  mutations: {
    setUnavailableDriversData (state, data) {
      for (let field in data) {
        state.unavailableDrivers[field] = data[field]
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/dispatch/unavailable-drivers.js